import React, {Component} from 'react';
import {FaIcon} from "../../../FaIcon";
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';

class LeadRow extends Component {
    constructor(props) {
        super(props);

        this.handleStateChange = this.handleStateChange.bind(this);
    }

    handleStateChange(event) {
        this.props.onStateChange(this.props.id, event.target.value)
    }

    render() {
        const { t } = this.props;
        return (
            <li className="lead-item">
                <div className="lead-data-group">
                    <p className="lead-label">{t('lead_row.client')}</p>
                    <p className="lead-name">{this.props.firstName} {this.props.lastName}</p>
                    <select name="status" onChange={this.handleStateChange} value={this.props.sellingState}>
                        <option value='WON'>{t('lead_state.won')}</option>
                        <option value='OPEN'>{t('lead_state.open')}</option>
                        <option value='LOST'>{t('lead_state.lost')}</option>
                        <option value='NOT_APPLICABLE'>{t('lead_state.not_applicable')}</option>
                    </select>
                </div>
                <div className="lead-data-group">
                    <p className="lead-label">{t('add_lead_form.contact_info')}</p>
                    <p className="contact lead-phone"><FaIcon iconName="phone"/>{this.props.phoneNumber}</p>
                    <p className="contact lead-email"><FaIcon iconName="envelope"/>{this.props.email}</p>
                </div>
                <div className="lead-data-group">
                    <p className="lead-label">{t('lead_row.message')}</p>
                    <p className="lead-message">{this.props.message}</p>
                </div>
                <div className="lead-data-group adwords-info">
                    <p className="lead-label">{t('lead_row.google_ads_info')}</p>
                    <p className="campaign">{t('lead_detail.campaign')} <span>{this.props.campaign}</span></p>
                    <p className="adgroup">{t('lead_detail.adgroup')} <span>{this.props.adgroup}</span></p>
                    <p className="keyword">{t('lead_detail.keyword')} <span>{this.props.keyword}</span></p>
                </div>
                <div className="lead-data-group">
                    <p className="lead-label">{t('lead_row.first_contact')}</p>
                    <p className="lead-date">{this.props.submittedOn}</p>
                    <Link className="lead-detail-button" to={`/${this.props.crmFrontPath}/lead/${this.props.id}/`}>
                        <FaIcon iconName="eye"/>{t('lead_row.see_more')}
                    </Link>
                </div>
            </li>
        )
    }
}

export default withTranslation()(LeadRow);